import { HelmetDexteel } from "@dexteel/mesf-core";
import { Stack, Typography } from "@mui/material";

import { TensileRequirementsPage } from "@/pages/configuration/pages/tensile-requirements/TensileRequirementsPage";
import { pageBgColor } from "@/utils/theme";

export const TensileRequirementsSpecPage = () => (
	<>
		<HelmetDexteel title="Tensile Requirements by Grade" />
		<Stack
			spacing={1}
			sx={{ backgroundColor: pageBgColor, px: 2, pt: 2, pb: 1 }}
		>
			<Stack direction="column" spacing={1} alignItems="baseline">
				<Typography variant="h5" fontWeight={600}>
					Tensile Requirements by Grade
				</Typography>
			</Stack>

			<TensileRequirementsPage readOnly />
		</Stack>
	</>
);
